import React from "react";
import BookSection from "../components/home/BookSection";
import ConditionSection from "../components/home/ConditionSection";
import TopicSection from "../components/home/TopicSection";
import ShareSection from "../components/home/ShareSection";
//import PricingSection from "../components/home/PricingSection";
//import VeterinariesSection from "../components/home/VeterinariesSection";

const HomeContent = () => {
  return (
    <div>
      <BookSection />
      <ConditionSection />
      <TopicSection />
      <ShareSection />
      {/*<PricingSection /> 
      <VeterinariesSection />*/}
    </div>
  );
};

export default HomeContent;
